import { ColDef } from 'ag-grid-community';

export const UsersColumnDef: ColDef[] = [
  {
    // ID
    headerName: 'ID',
    field: 'user_id',
    resizable: true,
    width: 50,
    hide: true,
  },
  {
    // First Name
    headerName: 'First Name',
    field: 'name_first',
    resizable: true,
    width: 150,
  },
  {
    // Last Name
    headerName: 'Last Name',
    field: 'name_last',
    resizable: true,
    width: 150,
  },
  {
    // Role
    headerName: 'Role',
    field: 'role',
    resizable: true,
    width: 100,
  },
  {
    // Position Title
    headerName: 'Position Title',
    field: 'position_title',
    resizable: true,
    width: 100,
  },
  {
    // Username
    headerName: 'Username',
    field: 'username',
    resizable: true,
    width: 150,
  },
  {
    // Email
    headerName: 'Email',
    field: 'email',
    resizable: true,
    width: 250,
    flex: 1
  },
  {
    // Digital Signature
    headerName: 'Digital Signature',
    field: 'signature',
    resizable: true,
    width: 100,
    flex: 1,
    cellRenderer: digitalSignatureRenderer
  },
  {
    // Password
    headerName: 'Password',
    field: 'password',
    resizable: true,
    width: 250,
    hide: true,
  },
];

function digitalSignatureRenderer(params: any): string {
  return params.value ? 'Signature Captured' : '';
}